import { useEffect } from "react";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { BUSINESS } from "@/lib/site";

const SECTIONS = [
  { title: "General Information", body: "The content on this website is provided by SUDHEER ELECTRONIC for general information about our products and services. While we work to keep it accurate and up to date, we make no guarantees about completeness or accuracy of product descriptions shown here." },
  { title: "Prices & Availability", body: "Product prices, offers, and stock availability change frequently. Nothing on this website is a final price quote. Please confirm the current price and stock by calling or messaging us on WhatsApp before visiting or ordering." },
  { title: "Brands & Trademarks", body: "All brand names, logos, and product names mentioned on this website belong to their respective owners and are used only to describe the genuine products we retail." },
  { title: "Warranty & Service", body: "Product warranty is provided by the respective manufacturer as per their terms, supported by the GST invoice we issue with every purchase. Warranty claims are subject to the brand's own service policies." },
  { title: "External Links", body: "This website links to third-party services such as WhatsApp for your convenience. We are not responsible for the content or policies of those services." },
  { title: "Contact", body: `Questions about this disclaimer? Email ${BUSINESS.email} or call/WhatsApp ${BUSINESS.phoneDisplay}.` },
];

export default function Disclaimer() {
  useEffect(() => { document.title = "Disclaimer | SUDHEER ELECTRONIC"; }, []);
  return (
    <div className="bg-[#f4f7fa] text-slate-900 antialiased">
      <Navbar />
      <section className="py-16 sm:py-20" data-testid="disclaimer-page">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <span className="text-[11px] font-bold text-blue-700 tracking-widest uppercase">Legal</span>
          <h1 className="text-4xl sm:text-5xl font-black text-slate-950 tracking-tight mt-3 mb-4">Disclaimer</h1>
          <p className="text-sm text-slate-600 mb-10">
            Please read this disclaimer before using the {BUSINESS.name} website.
          </p>
          <div className="space-y-4">
            {SECTIONS.map((s, i) => (
              <div key={s.title} data-testid={`disclaimer-section-${i + 1}`} className="p-6 bg-white rounded-xl border border-slate-200">
                <h2 className="text-sm font-bold text-slate-950 mb-2">{s.title}</h2>
                <p className="text-xs text-slate-600 leading-relaxed">{s.body}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}
